export default "__VITE_ASSET__BM_6tMFK__"